// Each table definition: columns shown + form fields for create/edit

export const TABLES = {
  equipment: {
    title: 'Equipment',
    tableKey: 'equipment',
    columns: [
      { key: 'Name', label: 'Name' },
      { key: 'Make', label: 'Make' },
      { key: 'Model', label: 'Model' },
      { key: 'Department', label: 'Department' },
      { key: 'Location', label: 'Location' },
      { key: 'Status', label: 'Status', pill: true },
      { key: 'Out of Service Since', label: 'OOS Since' },
      { key: 'Current Hours', label: 'Hours' },
      { key: 'System', label: 'System' },
      { key: 'Comments', label: 'Comments', comment: true },
    ],
    formFields: [
      { name: 'Name', label: 'Equipment Name', required: true, placeholder: 'e.g. Main Engine' },
      { name: 'Make', label: 'Make', placeholder: 'e.g. MAN' },
      { name: 'Model', label: 'Model', placeholder: 'e.g. B&W 12V48' },
      { name: 'Serial', label: 'Serial Number', placeholder: 'e.g. SN123456' },
      { name: 'Department', label: 'Department', type: 'select', options: [
        'Engineering','Deck','Interior','Safety','Navigation'
      ]},
      { name: 'System', label: 'System', type: 'select', options: [
        'Propulsion','Power Generation','Electrical','Navigation',
        'Fuel / Oil','Fresh Water (H2O)','Raw Water','Sewage','HVAC',
        'Air Conditioning','Refrigeration','Compressed Air','Hydraulics',
        'Safety & Training','Fire Fighting','Steering','Deck Equipment','Tenders','Machinery'
      ]},
      { name: 'Location', label: 'Location', placeholder: 'e.g. Engine Room' },
      { name: 'Status', label: 'Status', type: 'select', options: ['Operational','Out of Service'] },
      { name: 'Current Hours', label: 'Current Hours', type: 'number', placeholder: 'Operating hours' },
      { name: 'Supplier', label: 'Supplier', placeholder: 'Supplier or service company' },
      { name: 'Comments', label: 'Comments', type: 'textarea', placeholder: 'Any notes or comments' },
    ]
  },

  mlog: {
    title: 'Maintenance Log',
    tableKey: 'mlog',
    columns: [
      { key: 'Log ID', label: 'Log ID' },
      { key: 'Component', label: 'Component' },
      { key: 'Date Completed', label: 'Date' },
      { key: 'Task', label: 'Task' },
      { key: 'Work Description', label: 'Details', comment: true },
      { key: 'Technician', label: 'Technician' },
      { key: 'Hours at Service', label: 'Hours' },
      { key: 'Cost', label: 'Cost' },
    ],
    formFields: [
      { name: 'Log ID', label: 'Log ID', placeholder: 'e.g. LOG-006' },
      { name: 'Component', label: 'Component', placeholder: 'e.g. EQ-001' },
      { name: 'Task', label: 'Task', required: true, placeholder: 'e.g. Oil change' },
      { name: 'Work Description', label: 'Description', type: 'textarea', placeholder: 'Detailed description of work done' },
      { name: 'Date Completed', label: 'Date Completed', type: 'date', required: true },
      { name: 'Technician', label: 'Technician', placeholder: 'Full name' },
      { name: 'Parts Used', label: 'Parts Used', placeholder: 'e.g. Oil Filter A' },
      { name: 'Quantity', label: 'Quantity', type: 'number' },
      { name: 'Hours at Service', label: 'Hours at Service', type: 'number', placeholder: 'Operating hours' },
      { name: 'Cost', label: 'Cost', type: 'number', placeholder: '0.00' },
      { name: 'Comments', label: 'Comments', type: 'textarea', placeholder: 'Additional notes' },
    ]
  },

  mtask: {
    title: 'Maintenance Tasks',
    tableKey: 'mtask',
    columns: [
      { key: 'Task Name', label: 'Task' },
      { key: 'Status', label: 'Status', pill: true },
      { key: 'Next Service Date', label: 'Due Date' },
      { key: 'Next Service Hours', label: 'Due Hours' },
      { key: 'Last Service Date', label: 'Last Done' },
      { key: 'Last Service Hours', label: 'Last Done (h)' },
      { key: 'Frequency Hours', label: 'Freq Hours' },
      { key: 'Frequency Days', label: 'Freq Days' },
      { key: 'Equipment Name', label: 'Equipment' },
    ],
    formFields: [
      { name: 'Task Name', label: 'Task Name', required: true, placeholder: 'e.g. 500h engine service' },
      { name: 'Status', label: 'Status', type: 'select', options: ['Upcoming','Due','Overdue','Completed'] },
      { name: 'Frequency Hours', label: 'Frequency Hours', type: 'number', placeholder: 'e.g. 500' },
      { name: 'Frequency Days', label: 'Frequency Days', type: 'number', placeholder: 'e.g. 180' },
      { name: 'Next Service Date', label: 'Due Date', type: 'date' },
      { name: 'Next Service Hours', label: 'Due Hours', type: 'number', placeholder: 'e.g. 6580' },
      { name: 'Equipment', label: 'Equipment', type: 'equipment' },
    ]
  },

  inventory: {
    title: 'Inventory',
    tableKey: 'inventory',
    columns: [
      { key: 'Part UID', label: 'Part ID' },
      { key: 'Part Name', label: 'Item' },
      { key: 'Category', label: 'Category' },
      { key: 'Quantity', label: 'Qty' },
      { key: 'Min Stock', label: 'Min Stock' },
      { key: 'Status', label: 'Status', pill: true },
      { key: 'Location', label: 'Location' },
    ],
    formFields: [
      { name: 'Part UID', label: 'Part ID', placeholder: 'e.g. P-006' },
      { name: 'Part Name', label: 'Item Name', required: true, placeholder: 'e.g. Engine Oil 15W-40' },
      { name: 'Category', label: 'Category', type: 'select', options: ['Spare','Supply','Tool','Safety','Mooring','Electrical','Engine','Plumbing','Bridge','Deck','Interior','Galley','AV/IT','Chemical','Other'] },
      { name: 'Make', label: 'Make', placeholder: 'e.g. MAN' },
      { name: 'Part Number', label: 'Part Number', placeholder: 'e.g. OF-001' },
      { name: 'Quantity', label: 'Quantity', type: 'number' },
      { name: 'Min Stock', label: 'Min Stock', type: 'number' },
      { name: 'Status', label: 'Status (set from the stock; On Order by hand)', type: 'select', options: ['OK','Low Stock','Out of Stock','On Order'] },
      { name: 'Location', label: 'Location', placeholder: 'e.g. Engine Room Store' },
      { name: 'Department', label: 'Department (who is told when it runs low)', type: 'select', options: ['engine','deck','interior','galley','bridge','other'] },
      { name: 'Critical Spare', label: 'Critical spare', type: 'yesno', hint: 'Low stock adds it to a DRAFT order of the preferred supplier (never sent)' },
      { name: 'Preferred Supplier', label: 'Preferred supplier', type: 'supplier' },
    ]
  },

  docs: {
    title: 'Documents',
    tableKey: 'docs',
    columns: [
      { key: 'Title', label: 'Title' },
      { key: 'Document Type', label: 'Type' },
      { key: 'Issued Date', label: 'Issued' },
      { key: 'Expiry Date', label: 'Expires' },
      { key: 'Status', label: 'Status', pill: true },
    ],
    formFields: [
      { name: 'Title', label: 'Document Title', required: true, placeholder: 'e.g. Safety Management Certificate' },
      { name: 'Document Type', label: 'Document Type', type: 'select', options: [
        'Certificate','Manual','License','Report','Log','Invoice','Survey','Crew','Safety','Accounting',
        'Construction','Correspondence','Drawing','Fluid Sample','Forms','Handover Notes','Image',
        'Legal','Parts List','Procedure','Quote','Tech Data Sheet','Warranty',
        'Insurance','Class','Flag','Tender','Toys','Other'
      ]},
      { name: 'Doc ID', label: 'Doc ID / Reference', placeholder: 'e.g. SMC-2024-001' },
      { name: 'Issued Date', label: 'Issued Date', type: 'date' },
      { name: 'Expiry Date', label: 'Expiry Date', type: 'date' },
      { name: 'Status', label: 'Status', type: 'select', options: ['Valid','Expiring Soon','Expired','Archived'] },
      { name: 'Notes', label: 'Notes', type: 'textarea', placeholder: 'Additional information...' },
      { name: 'File URL', label: 'File URL', type: 'url', placeholder: 'https://...' },
    ]
  },

  day_log: {
    title: 'Day Log',
    tableKey: 'day_log',
    columns: [
      { key: 'Date', label: 'Date' },
      { key: 'Time', label: 'Time' },
      { key: 'Watch Keeper', label: 'Watch Keeper' },
      { key: 'Status', label: 'Status', pill: true },
      { key: 'Position', label: 'Position' },
      { key: 'Wind Direction', label: 'Wind Dir' },
      { key: 'Wind Force', label: 'Beaufort' },
      { key: 'Air Temp', label: 'Air °C' },
      { key: 'Water Temp', label: 'Water °C' },
      { key: 'Pressure', label: 'hPa' },
      { key: 'Visibility', label: 'Visibility (nm)' },
      { key: 'Cloud Cover', label: 'Cloud Cover' },
      { key: 'Significant Events', label: 'Events' },
    ],
    formFields: [
      { name: 'Date', label: 'Date', type: 'date', required: true },
      { name: 'Time', label: 'Time (HH:MM)', required: true, placeholder: 'e.g. 08:00' },
      { name: 'Watch Keeper', label: 'Watch Keeper', required: true, placeholder: 'e.g. John Smith' },
      { name: 'Status', label: 'Vessel Status', type: 'select', required: true, options: ['At Marina', 'At Anchor'] },
      { name: 'Position', label: 'Position / Anchorage', placeholder: 'e.g. Portofino, Italy' },
      { name: 'Wind Direction', label: 'Wind Direction', type: 'select', options: ['N','NNE','NE','ENE','E','ESE','SE','SSE','S','SSW','SW','WSW','W','WNW','NW','NNW'] },
      { name: 'Wind Force', label: 'Wind Force (Beaufort 0-12)', type: 'number', placeholder: '0-12' },
      { name: 'Visibility', label: 'Visibility (nm)', type: 'number', placeholder: 'e.g. 10' },
      { name: 'Cloud Cover', label: 'Cloud Cover', type: 'select', options: ['Clear','Partly Cloudy','Overcast'] },
      { name: 'Pressure', label: 'Barometric Pressure (hPa)', type: 'number', placeholder: 'e.g. 1013' },
      { name: 'Air Temp', label: 'Air Temperature (°C)', type: 'number', placeholder: 'e.g. 24' },
      { name: 'Water Temp', label: 'Water Temperature (°C)', type: 'number', placeholder: 'e.g. 21' },
      { name: 'Significant Events', label: 'Significant Events', type: 'textarea', placeholder: 'Describe any significant events during this watch...' },
    ]
  },

  engine_log: {
    title: 'Engine Room Log',
    tableKey: 'engine_log',
    columns: [
      { key: 'Date', label: 'Date' },
      { key: 'Location', label: 'Location' },
      { key: 'Mode', label: 'Mode', pill: true },
      { key: 'Fuel Total', label: 'Fuel (gal)' },
      { key: 'Fresh Water', label: 'Fresh Water' },
      { key: 'ME Port Hours', label: 'ME Port hrs' },
      { key: 'ME Stbd Hours', label: 'ME Stbd hrs' },
      { key: 'Gen Port Hours', label: 'Gen Port hrs' },
      { key: 'Gen Stbd Hours', label: 'Gen Stbd hrs' },
      { key: 'Bilges Dry', label: 'Bilges', pill: true },
      { key: 'Signed By', label: 'Signed By' },
    ],
    formFields: []
  },

  running_log: {
    title: 'Running Log',
    tableKey: 'running_log',
    columns: [
      { key: 'Date', label: 'Date' },
      { key: 'Voyage Origin', label: 'From' },
      { key: 'Voyage Destination', label: 'To' },
      { key: 'Departure Time', label: 'Dep Time' },
      { key: 'Arrival Time', label: 'Arr Time' },
      { key: 'Departure Fuel', label: 'Dep Fuel' },
      { key: 'Arrival Fuel', label: 'Arr Fuel' },
      { key: 'Fuel Consumption', label: 'Fuel Used' },
      { key: 'Number of Crew', label: 'Crew' },
      { key: 'Number of Guests', label: 'Guests' },
    ],
    formFields: []
  },

  calendar: {
    title: 'Calendar',
    tableKey: 'calendar',
    columns: [
      { key: 'Title', label: 'Title' },
      { key: 'Type', label: 'Type', pill: true },
      { key: 'Start Date', label: 'Start' },
      { key: 'End Date', label: 'End' },
      { key: 'Start Time', label: 'Time' },
      { key: 'All Day', label: 'All Day' },
      { key: 'Notes', label: 'Notes' },
    ],
    formFields: []
  },
  charters: {
    title: 'Charters',
    tableKey: 'charters',
    columns: [
      { key: 'Charter Ref', label: 'Charter Ref' },
      { key: 'Status', label: 'Status', pill: true },
      { key: 'Charter Type', label: 'Type', pill: true },
      { key: 'Start Date', label: 'Start' },
      { key: 'End Date', label: 'End' },
      { key: 'Embark Port', label: 'Embark' },
      { key: 'Disembark Port', label: 'Disembark' },
      { key: 'Lead Guest', label: 'Guest' },
      { key: 'Number of Guests', label: 'Guests' },
      { key: 'Broker', label: 'Broker' },
      { key: 'Charter Rate', label: 'Rate' },
      { key: 'Currency', label: 'Currency' },
      { key: 'Deposit Status', label: 'Deposit', pill: true },
      { key: 'Notes', label: 'Notes' },
    ],
    formFields: [
      { name: 'Charter Ref', label: 'Charter Ref', required: true, placeholder: 'e.g. Aug Caruso Charter' },
      { name: 'Status', label: 'Status', type: 'select', required: true, options: ['Inquiry','Option','Confirmed','Active','Completed','Cancelled'] },
      { name: 'Charter Type', label: 'Charter Type', type: 'select', options: ['Private','Corporate','Day Charter'] },
      { name: 'Start Date', label: 'Start Date', type: 'date', required: true },
      { name: 'End Date', label: 'End Date', type: 'date' },
      { name: 'Embark Port', label: 'Embark Port', placeholder: 'e.g. Monaco' },
      { name: 'Disembark Port', label: 'Disembark Port', placeholder: 'e.g. Nice' },
      { name: 'Itinerary', label: 'Itinerary', type: 'textarea', placeholder: 'Ports and route...' },
      { name: 'Broker', label: 'Broker / Agency' },
      { name: 'Broker Contact', label: 'Broker Contact', placeholder: 'Phone or email' },
      { name: 'Lead Guest', label: 'Lead Guest' },
      { name: 'Number of Guests', label: 'Number of Guests', type: 'number', placeholder: 'e.g. 8' },
      { name: 'Special Requests', label: 'Special Requests', type: 'textarea', placeholder: 'Allergies, dietary, preferences...' },
      { name: 'Charter Rate', label: 'Charter Rate', type: 'number' },
      { name: 'APA', label: 'APA', type: 'number' },
      { name: 'Currency', label: 'Currency', type: 'select', options: ['EUR','USD','GBP'] },
      { name: 'Deposit Status', label: 'Deposit Status', type: 'select', options: ['Paid','Pending'] },
      { name: 'Notes', label: 'Notes', type: 'textarea' },
    ]
  },
  port_calls: {
    title: 'Port Calls',
    tableKey: 'port_calls',
    columns: [
      { key: 'Port', label: 'Port' },
      { key: 'Country', label: 'Country' },
      { key: 'Status', label: 'Status', pill: true },
      { key: 'ETA Date', label: 'ETA' },
      { key: 'ETD Date', label: 'ETD' },
      { key: 'Berth', label: 'Berth/Anchorage' },
      { key: 'Agent', label: 'Agent' },
      { key: 'Clearance Status', label: 'Clearance', pill: true },
      { key: 'Pilot Required', label: 'Pilot' },
      { key: 'Notes', label: 'Notes' },
    ],
    formFields: [
      { name: 'Port', label: 'Port', required: true },
      { name: 'Country', label: 'Country' },
      { name: 'Status', label: 'Status', type: 'select', required: true, options: ['Planned','Confirmed','Arrived','Departed','Cancelled'] },
      { name: 'ETA Date', label: 'ETA Date', type: 'date' },
      { name: 'ETA Time', label: 'ETA Time', placeholder: 'e.g. 08:00' },
      { name: 'ETD Date', label: 'ETD Date', type: 'date' },
      { name: 'ETD Time', label: 'ETD Time', placeholder: 'e.g. 17:00' },
      { name: 'Berth', label: 'Berth / Anchorage' },
      { name: 'Agent', label: 'Agent' },
      { name: 'Agent Contact', label: 'Agent Contact', placeholder: 'Phone or email' },
      { name: 'Clearance Status', label: 'Clearance Status', type: 'select', options: ['Not Started','In Progress','Cleared'] },
      { name: 'Pilot Required', label: 'Pilot Required', type: 'select', options: ['Yes','No'] },
      { name: 'Services Requested', label: 'Services Requested', type: 'textarea', placeholder: 'Fuel, water, provisions, waste...' },
      { name: 'Notes', label: 'Notes', type: 'textarea' },
    ]
  },
  marina_bookings: {
    title: 'Marina Bookings',
    tableKey: 'marina_bookings',
    columns: [
      { key: 'Marina Name', label: 'Marina' },
      { key: 'Location', label: 'Location' },
      { key: 'Status', label: 'Status', pill: true },
      { key: 'Arrival Date', label: 'Arrival' },
      { key: 'Departure Date', label: 'Departure' },
      { key: 'Berth Number', label: 'Berth' },
      { key: 'Rate', label: 'Rate' },
      { key: 'Currency', label: 'Currency' },
      { key: 'Deposit Status', label: 'Deposit', pill: true },
      { key: 'Booking Ref', label: 'Ref' },
      { key: 'Notes', label: 'Notes' },
    ],
    formFields: [
      { name: 'Marina Name', label: 'Marina Name', required: true },
      { name: 'Location', label: 'Location / Port' },
      { name: 'Status', label: 'Status', type: 'select', required: true, options: ['Inquiry','Requested','Confirmed','Cancelled'] },
      { name: 'Arrival Date', label: 'Arrival Date', type: 'date' },
      { name: 'Departure Date', label: 'Departure Date', type: 'date' },
      { name: 'Berth Number', label: 'Berth Number' },
      { name: 'LOA Booked', label: 'LOA Booked (m)', type: 'number' },
      { name: 'Rate', label: 'Rate', type: 'number' },
      { name: 'Currency', label: 'Currency', type: 'select', options: ['EUR','USD','GBP'] },
      { name: 'Deposit Status', label: 'Deposit Status', type: 'select', options: ['Paid','Pending','Not Required'] },
      { name: 'Booking Ref', label: 'Booking Ref' },
      { name: 'Contact', label: 'Marina Contact', placeholder: 'Phone or email' },
      { name: 'Notes', label: 'Notes', type: 'textarea' },
    ]
  }
}
